{
  "propertyCompanyGroup": {
    "name": "DAS Domus Arctica -säätiö"
  },
  "bulletin": "Meddelanden",
  "moreBulletins": "Fler anslag",
  "noBulletins": "Inga nya anslag",
  "test": "test",
  "hi": "Hej",
  "email": "E-post",
  "emailForContact": "E-post för kontakt",
  "residentId": "Boendesidans användarnamn",
  "phone": "Telefon",
  "comingSoon": "På kommande",
  "edit": "Redigera",
  "cancel": "Avbryt",
  "closeButton": "Stäng",
  "save": "Spara",
  "preview": "Förhandsgranska",
  "next": "Nästa",
  "file": "Fil",
  "thankYou": "Tack",
  "formSent": "{{form}} har skickats!",
  "editFormSent": "{{form}} har redigerats.",
  "backToHome": "Tillbaka till framsidan",
  "back": "Tillbaka",
  "impersonatorWriteOnlyModeError": "Som användare inloggad på kundens vägnar har man inte rätt att ändra uppgifterna.",
  "movedOutReadOnlyModeError": "Du har flyttat ut, så du kan endast se uppgifterna samt skicka meddelanden, frågor och feedback.",
  "notKnown": "Ej känd",
  "yes": "Ja",
  "no": "Nej",
  "additionalNotification": "Vid brådskande fall kontakta kundtjänsten.",
  "logOut": "Logga ut",
  "showMore": "Visa mer",
  "waysToCommunicate": "Kommunikationsönskemål",
  "communicationByEmail": "E-post",
  "communicationBySms": "Textmeddelande",
  "marketingAllowed": "Marknadsföringstillstånd",
  "paperInvoice": "Pappersfaktura",
  "eInvoice": "E-faktura",
  "inUse": "I bruk",
  "notInUse": "Inte i bruk",
  "views": {
    "home": "Framsida",
    "userInfo": "Egna uppgifter",
    "payments": "Fakturor och betalningsuppgifter",
    "defectNotice": "Gör en felanmälan",
    "documents": "Dokument",
    "bulletin": "Anslag",
    "building": "Fastighetsinformation",
    "bulletinBoard": "Alla anslag",
    "contactInfo": "Kontaktuppgifter"
  },
  "taskLinks": {
    "messages": "Meddelanden",
    "newMessagesCount_one": "{{count}} nytt meddelande",
    "newMessagesCount_other": "{{count}} nya meddelanden",
    "defectNotice": "Felanmälan",
    "payments": "Betalningar",
    "saunaReservation": "Bastu",
    "commonAreaReservations": "Samlingslokaler",
    "moveNotice": "Uppsägning",
    "residentChanges": "Ändringar av boende"
  },
  "navbar": {
    "profile": "Öppna profil",
    "home": "Framsida",
    "transactions": "Tjänster",
    "faultReport": "Felanmälan",
    "terminateContract": "Säg upp avtalet",
    "residentChanges": "Ändringar av boende",
    "messages": "Meddelanden",
    "feedback": "Återföring",
    "questions": "Frågor",
    "userInfo": "Egna uppgifter",
    "payments": "Betalningsuppgifter",
    "ownProperty": "Eget hem",
    "documents": "Dokument",
    "building": "Fastighetsinformation",
    "openMenu": "Öppna menyn",
    "openProfile": "Öppna profilen",
    "bulletinBoard": "Alla anslag",
    "contactInfo": "Kontaktuppgifter",
    "parkingSpots": "Parkeringsplatser",
    "saunaReservations": "Bastuturer",
    "laundryReservations": "Tvättreservationer",
    "gymBooking": "Gymbokningar",
    "gymReservations": "Gymbokningar",
    "commonAreaReservations": "Samlingslokaler",
    "storages": "Förråd"
  },
  "placeholders": {
    "date": "dd.mm.åååå",
    "select": "Välj"
  },
  "datePicker": {
    "monthEndOnly": "Avtalets slutdatum är alltid månadens sista dag",
    "monthEndOnlyValidation": "Välj månadens sista dag"
  },
  "today": "Idag",
  "week": "Vecka",
  "month": "Månad",
  "copy": "Kopiera",
  "copyFailed": "Kopieringen misslyckades",
  "userInfo": {
    "securitySectionHeader": "Datasäkerhet",
    "changePassword": "Byt lösenord",
    "strongAuth": {
      "sectionHeader": "Autentisering",
      "infoText": "Att göra avtalsändringar kräver autentisering. Du kan autentisera dig via knappen nedan.",
      "authButton": "Autentisera"
    },
    "description1": "Vi använder denna kontaktinformation för bostadserbjudanden, felanmälningar, avtalsändringar och andra informationsrelaterade ärenden.",
    "description2": "E-postadressen du använder som ditt boendekonto kan endast ändras genom att registrera dig igen.",
    "communicationPreferencesInfo": "Välj hur du i första hand vill ta emot meddelanden. Valet påverkar inte via vilka kanaler nödvändiga meddelanden kan levereras.",
    "permissionsHeader": "Tillstånd",
    "marketingAllowedDescription": "Jag vill höra om förmåner och kampanjer",
    "electronicServicesConsent": "Tillstånd för elektronisk kommunikation",
    "electronicServicesConsentDescription": "Officiella dokument får skickas till mig elektroniskt",
    "removeUser": {
      "buttonText": "Ta bort användarnamnet",
      "confirmationText": "Är du säker på att du vill ta bort användarnamnet?"
    }
  },
  "complete": "Klar",
  "tryAgain": "Försök på nytt",
  "reloadPage": "Ladda om sidan",
  "newVersionAvailable": "En ny version av boendesidorna finns tillgänglig. Ladda om sidan.",
  "newVersionTitle": "Boendesidorna har uppdaterats!",
  "closeWindow": "Stäng utan att ladda om",
  "alt": {
    "illustration": "illustration"
  },
  "uploadFilesInputText": "Klicka här eller dra filen. Maximal storlek är 10 MB.",
  "uploadFilesInputError": "Filen du bifogade är för stor eller har fel format. Vi accepterar följande filtyper",
  "cookieConsent": {
    "readMoreLinkText": "Läs mer om Pandias cookiepolicy här",
    "readMoreLink": "https://pandia.fi/",
    "privacyStatementLink": "https://www.das.fi/fi/tietoa-dasista/henkilotietojen-kaytto",
    "accessibilityStatementLink": "",
    "termsOfUseLink": ""
  },
  "buildingInfo": {
    "title": "Grunduppgifter",
    "district": "Stadsdel",
    "constructionDate": "Byggår",
    "realPropertyAreasTotal": "Lägenheter",
    "heatingMethod": "Uppvärmningsmetod",
    "internetOperator": "Internetoperatör",
    "internetProvider": "Internetleverantör",
    "connectionSpeed": "Anslutningshastighet",
    "realPropertyPictureAlt": "Bild på fastigheten",
    "contactInformation": "Kontaktinformation",
    "noContactInformation": "Ingen kontaktinformation tillgänglig",
    "sales": "Försäljning",
    "residentsCommittee": "Boendekommitté",
    "giveFeedback": "Ge feedback",
    "askQuestion": "Fråga om boende",
    "heatingMethods": {
      "airToWaterHeatPump": "Luft-vattenvärmepump",
      "districtAndExhaustAirHeatPump": "Fjärrvärme och frånluftsvärmepump",
      "districtAndSolar": "Fjärrvärme och solenergi",
      "districtHeating": "Fjärrvärme",
      "electricHeating": "Eluppvärmning",
      "gas": "Gas",
      "geothermalAndSolar": "Geotermisk uppvärmning och solenergi",
      "geothermalHeating": "Geotermisk uppvärmning",
      "naturalGasHeating": "Naturgasuppvärmning",
      "noHeating": "Ingen uppvärmning",
      "notSet": "Ej angivet",
      "oilHeating": "Oljeuppvärmning",
      "solar": "Solenergi"
    }
  },
  "charactersRemaining": "Återstående tecken: {{count}}",
  "sensitiveDataWarning": "Observera! Vänligen notera att meddelandet inte får innehålla känsliga personuppgifter, såsom personnummer, lösenord eller annan konfidentiell information.",
  "dateTime": {
    "weekAbbreviation": "v.",
    "today": "Idag",
    "months": {
      "in": {
        "10": "i oktober",
        "11": "i november",
        "12": "i december",
        "01": "i januari",
        "02": "i februari",
        "03": "i mars",
        "04": "i april",
        "05": "i maj",
        "06": "i juni",
        "07": "i juli",
        "08": "i augusti",
        "09": "i september"
      }
    }
  },
  "residentDetailsTitle": "Tilläggsinformation",
  "textEditor": {
    "heading1": "Rubrik 1",
    "heading2": "Rubrik 2",
    "paragraph": "Brödtext",
    "bulletedList": "Punktlista",
    "numberedList": "Numrerad lista",
    "text": "Text",
    "link": "Länk",
    "addLink": "Lägg till länk",
    "removeLink": "Ta bort",
    "italic": "Kursivera",
    "bold": "Fetstil",
    "underline": "Understryk",
    "undo": "Ångra",
    "redo": "Gör om",
    "textRequired": "Text krävs",
    "linkRequired": "Länk krävs",
    "linkInvalid": "Länken är inte en giltig webbadress"
  },
  "openFile": {
    "loadingTitle": "Laddar…",
    "loading": "Laddar dokumentet…",
    "loadingSlow": "Laddningen tar längre tid än vanligt…",
    "errorTitle": "Fel",
    "failed": "Det gick inte att öppna filen."
  }
}